import { render, staticRenderFns } from "./veHqWupin.vue?vue&type=template&id=d6228fe4&scoped=true"
import script from "./veHqWupin.vue?vue&type=script&lang=js"
export * from "./veHqWupin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6228fe4",
  null
  
)

export default component.exports